import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { useContext } from "react";
import { ScreenStatusContext } from "../../context/ScreenStatusContext";

const infoTableCellSx = {
  fontSize: 18,
};

// 店舗入力情報表
// props...shopInfoDataInput = 店舗入力情報 setShopInfoDataInput = 店舗入力情報をセットする(Object) => (void) customerName=取引先名
export default function ShopInfoEditTable(props) {
  const { shop, customerName } = props;
  
  // 画面ステータスをcontextから取得
  const {isChanged, setChanged} = useContext(ScreenStatusContext);

  // テキストボックス　フォーカス時に全選択する
  const onFocusInput = (event) => {
    event.target.select();
  };

  // // テキストボックスに入力変更があったとき
  // const handleChangeInput = (prop) => (event) => {
  //   setShopInfoDataInput({ ...shopInfoDataInput, [prop]: event.target.value });
  // };

  // // 郵便番号フォーカスOFF時
  // const handleBlurPostCodeInput = (event) => {
  //   setShopInfoDataInput({
  //     ...shopInfoDataInput,
  //     post_code: event.target.value.replaceAll(/[^0-9\-]/g, ""),
  //   });
  // };

  // 入力変更時処理
  const onChangeShopInput = (value, prop) => (event) => {
    let valueChanged = shop.Value[prop] !== value;
    shop.handleChange(value, prop);
    setChanged(isChanged || valueChanged);
  }

  // // 番号フォーカスOFF時
  const handleBlurNumberHyphenInput = (prop) => (event) => {
    shop.handleChange(event.target.value.replaceAll(/[^0-9\-]/g, prop));
  };

  return (
    <TableContainer component={Box}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              取引先名
            </TableCell>
            <TableCell sx={infoTableCellSx}>{customerName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  店舗名&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                // onFocus={onFocusInput}
                onChange={(e) => onChangeShopInput(e.target.value, "shopName")(e)}
                value={shop.Value.shopName}
                sx={{ width: 200 }}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  店舗名ふりがな&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    // onFocus={onFocusInput}
                    onChange={(e) =>
                      onChangeShopInput(e.target.value, "shopNameFurigana")(e)
                    }
                    value={shop.Value.shopNameFurigana}
                    sx={{ width: 400 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>ひらがなのみ</Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
          {/* <TableRow>
            <TableCell sx={infoTableCellSx}>郵便番号 </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    type="tel"
                    // onFocus={onFocusInput}
                    // onBlur={handleBlurPostCodeInput}
                    // 〒
                    // onChange={(e)=>shop.handleChange(e.target.value,"shopNameFurigana")}
                    // value={shop.Value.shopNameFurigana}
                    inputProps={{ maxLength: 8 }}
                    sx={{ width: 100 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>半角数字のみ</Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow> */}
          <TableRow>
            <TableCell sx={infoTableCellSx}>住所</TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1}>
                <Grid item xs="auto">
                  <OutlinedInput
                    onFocus={onFocusInput}
                    onChange={(e) =>
                      onChangeShopInput(e.target.value, "address")(e)
                    }
                    value={shop.Value.address}
                    sx={{ width: 400 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>半角数字のみ</Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>TEL</TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    type="tel"
                    onFocus={onFocusInput}
                    // onBlur={handleBlurNumberHyphenInput("tel")}
                    onChange={(e) => onChangeShopInput(e.target.value, "tel")(e)}
                    value={shop.Value.tel}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>
                    半角数字, ハイフン(-)のみ
                  </Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>FAX</TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    type="tel"
                    onFocus={onFocusInput}
                    onBlur={handleBlurNumberHyphenInput("fax")}
                    onChange={(e) => onChangeShopInput(e.target.value, "fax")(e)}
                    value={shop.Value.fax}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>
                    半角数字, ハイフン(-)のみ
                  </Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>Email</TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    type="email"
                    onFocus={onFocusInput}
                    onChange={(e) => onChangeShopInput(e.target.value, "email")(e)}
                    value={shop.Value.email}
                    sx={{ width: 400 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>半角英数記号のみ</Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>買人No.</TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    type="tel"
                    onFocus={onFocusInput}
                    // onBlur={handleBlurNumberHyphenInput("buyer_no")}
                    onChange={(e) =>
                      onChangeShopInput(e.target.value, "buyerNo")(e)
                    }
                    value={shop.Value.buyerNo}
                    sx={{ width: 100 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>
                    半角数字, ハイフン(-)のみ
                  </Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  コンテナ数&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs="auto">
                  <OutlinedInput
                    type="tel"
                    onFocus={onFocusInput}
                    onChange={(e) =>
                      onChangeShopInput(e.target.value, "containerQuantity")(e)
                    }
                    value={shop.Value.containerQuantity}
                    sx={{ width: 100 }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography fontSize={14}>半角数字のみ</Typography>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
